export const SCENARIO_LIBRARY_DATA = {
  SCENARIO_DATA: [
    {
      scenario_name: 'scenario_1',
      created_date: '19-09-2024',
      user: 'user_name',
      scenario_id: 1,
      input: [
        {
          State: 'Punjab',
          Category: 'Core Sparkling',
          Bottler: 'LBPL',
          Brand: 'Fanta',
          Pack_Segment: 'SS PET',
          Pack_Size: 250,
          Current_Price: 20,
          New_Price: 15,
          Current_Distribution: 31.29469142246446,
          New_Distribution: 'Base',
          Action: 'Pricing',
          valid: true,
          scenario_id: 1,
        },
        {
          State: 'Punjab',
          Category: 'Core Sparkling',
          Bottler: 'LBPL',
          Brand: 'Limca',
          Pack_Segment: 'SS PET',
          Pack_Size: 250,
          Current_Price: 20,
          New_Price: 15,
          Current_Distribution: 49.807686785359955,
          New_Distribution: 'Base',
          Action: 'Pricing',
          valid: true,
          scenario_id: 1,
        },
        {
          State: 'Punjab',
          Category: 'Core Sparkling',
          Bottler: 'LBPL',
          Brand: 'Thums Up',
          Pack_Segment: 'SS PET',
          Pack_Size: 250,
          Current_Price: 20,
          New_Price: 15,
          Current_Distribution: 15.820655533960009,
          New_Distribution: 'Base',
          Action: 'Pricing',
          valid: true,
          scenario_id: 1,
        },
      ],
      txn_gr: 0.01,
      vol_uc_gr: 0.01,
      nr_gr: 0.01,
      share_change: 0.5,
      ou_gp: 0.3,
      system_gp: 0.6,
      status: 'draft',
    },
    {
      scenario_name: 'scenario_2',
      created_date: '19-09-2024',
      user: 'user_name',
      scenario_id: 2,
      input: [
        {
          State: 'Punjab',
          Category: 'Core Sparkling',
          Bottler: 'LBPL',
          Brand: 'Fanta',
          Pack_Segment: 'SS PET',
          Pack_Size: 250,
          Current_Price: 20,
          New_Price: 15,
          Current_Distribution: 31.29469142246446,
          New_Distribution: 'Base',
          Action: 'Pricing',
          valid: true,
          scenario_id: 2,
        },
        {
          State: 'Punjab',
          Category: 'Core Sparkling',
          Bottler: 'LBPL',
          Brand: 'Limca',
          Pack_Segment: 'SS PET',
          Pack_Size: 250,
          Current_Price: 20,
          New_Price: 15,
          Current_Distribution: 49.807686785359955,
          New_Distribution: 'Base',
          Action: 'Pricing',
          valid: true,
          scenario_id: 2,
        },
        {
          State: 'Punjab',
          Category: 'Core Sparkling',
          Bottler: 'LBPL',
          Brand: 'Thums Up',
          Pack_Segment: 'SS PET',
          Pack_Size: 250,
          Current_Price: 20,
          New_Price: 15,
          Current_Distribution: 15.820655533960009,
          New_Distribution: 'Base',
          Action: 'Pricing',
          valid: true,
          scenario_id: 2,
        },
      ],
      txn_gr: 0.01,
      vol_uc_gr: 0.01,
      nr_gr: 0.01,
      share_change: 0.5,
      ou_gp: 0.3,
      system_gp: 0.6,
      status: 'draft',
    },
    {
      scenario_name: 'scenario_5',
      created_date: '20-09-2024',
      user: 'user_name',
      scenario_id: 3,
      input: [
        {
          State: 'Punjab',
          Category: 'Core Sparkling',
          Bottler: 'LBPL',
          Brand: 'Fanta',
          Pack_Segment: 'SS PET',
          Pack_Size: 250,
          Current_Price: 20,
          New_Price: 15,
          Current_Distribution: 31.29469142246446,
          New_Distribution: 'Base',
          Action: 'Pricing',
          valid: true,
          scenario_id: 3,
        },
        {
          State: 'Punjab',
          Category: 'Core Sparkling',
          Bottler: 'LBPL',
          Brand: 'Limca',
          Pack_Segment: 'SS PET',
          Pack_Size: 250,
          Current_Price: 20,
          New_Price: 15,
          Current_Distribution: 49.807686785359955,
          New_Distribution: 'Base',
          Action: 'Pricing',
          valid: true,
          scenario_id: 3,
        },
        {
          State: 'Punjab',
          Category: 'Core Sparkling',
          Bottler: 'LBPL',
          Brand: 'Thums Up',
          Pack_Segment: 'SS PET',
          Pack_Size: 250,
          Current_Price: 20,
          New_Price: 15,
          Current_Distribution: 15.820655533960009,
          New_Distribution: 'Base',
          Action: 'Pricing',
          valid: true,
          scenario_id: 3,
        },
      ],
      txn_gr: 0.01,
      vol_uc_gr: 0.01,
      nr_gr: 0.01,
      share_change: 0.5,
      ou_gp: 0.3,
      system_gp: 0.6,
      status: 'complete',
    },
    {
      scenario_name: 'scenario_6',
      created_date: '20-09-2024',
      user: 'user_name',
      scenario_id: 3,
      input: [
        {
          State: 'Punjab',
          Category: 'Core Sparkling',
          Bottler: 'LBPL',
          Brand: 'Fanta',
          Pack_Segment: 'SS PET',
          Pack_Size: 250,
          Current_Price: 20,
          New_Price: 15,
          Current_Distribution: 31.29469142246446,
          New_Distribution: 'Base',
          Action: 'Pricing',
          valid: true,
          scenario_id: 3,
        },
        {
          State: 'Punjab',
          Category: 'Core Sparkling',
          Bottler: 'LBPL',
          Brand: 'Limca',
          Pack_Segment: 'SS PET',
          Pack_Size: 250,
          Current_Price: 20,
          New_Price: 15,
          Current_Distribution: 49.807686785359955,
          New_Distribution: 'Base',
          Action: 'Pricing',
          valid: true,
          scenario_id: 3,
        },
        {
          State: 'Punjab',
          Category: 'Core Sparkling',
          Bottler: 'LBPL',
          Brand: 'Thums Up',
          Pack_Segment: 'SS PET',
          Pack_Size: 250,
          Current_Price: 20,
          New_Price: 15,
          Current_Distribution: 15.820655533960009,
          New_Distribution: 'Base',
          Action: 'Pricing',
          valid: true,
          scenario_id: 3,
        },
      ],
      txn_gr: 0.01,
      vol_uc_gr: 0.01,
      nr_gr: 0.01,
      share_change: 0.5,
      ou_gp: 0.3,
      system_gp: 0.6,
      status: 'complete',
    },
    {
      scenario_name: 'scenario_7',
      created_date: '20-09-2024',
      user: 'user_name',
      scenario_id: 3,
      input: [
        {
          State: 'Punjab',
          Category: 'Core Sparkling',
          Bottler: 'LBPL',
          Brand: 'Fanta',
          Pack_Segment: 'SS PET',
          Pack_Size: 250,
          Current_Price: 20,
          New_Price: 15,
          Current_Distribution: 31.29469142246446,
          New_Distribution: 'Base',
          Action: 'Pricing',
          valid: true,
          scenario_id: 3,
        },
        {
          State: 'Punjab',
          Category: 'Core Sparkling',
          Bottler: 'LBPL',
          Brand: 'Limca',
          Pack_Segment: 'SS PET',
          Pack_Size: 250,
          Current_Price: 20,
          New_Price: 15,
          Current_Distribution: 49.807686785359955,
          New_Distribution: 'Base',
          Action: 'Pricing',
          valid: true,
          scenario_id: 3,
        },
        {
          State: 'Punjab',
          Category: 'Core Sparkling',
          Bottler: 'LBPL',
          Brand: 'Thums Up',
          Pack_Segment: 'SS PET',
          Pack_Size: 250,
          Current_Price: 20,
          New_Price: 15,
          Current_Distribution: 15.820655533960009,
          New_Distribution: 'Base',
          Action: 'Pricing',
          valid: true,
          scenario_id: 3,
        },
      ],
      txn_gr: 0.01,
      vol_uc_gr: 0.01,
      nr_gr: 0.01,
      share_change: 0.5,
      ou_gp: 0.3,
      system_gp: 0.6,
      status: 'complete',
    },
    {
      scenario_name: 'scenario_8',
      created_date: '20-09-2024',
      user: 'user_name',
      scenario_id: 3,
      input: [
        {
          State: 'Punjab',
          Category: 'Core Sparkling',
          Bottler: 'LBPL',
          Brand: 'Fanta',
          Pack_Segment: 'SS PET',
          Pack_Size: 250,
          Current_Price: 20,
          New_Price: 15,
          Current_Distribution: 31.29469142246446,
          New_Distribution: 'Base',
          Action: 'Pricing',
          valid: true,
          scenario_id: 3,
        },
        {
          State: 'Punjab',
          Category: 'Core Sparkling',
          Bottler: 'LBPL',
          Brand: 'Limca',
          Pack_Segment: 'SS PET',
          Pack_Size: 250,
          Current_Price: 20,
          New_Price: 15,
          Current_Distribution: 49.807686785359955,
          New_Distribution: 'Base',
          Action: 'Pricing',
          valid: true,
          scenario_id: 3,
        },
        {
          State: 'Punjab',
          Category: 'Core Sparkling',
          Bottler: 'LBPL',
          Brand: 'Thums Up',
          Pack_Segment: 'SS PET',
          Pack_Size: 250,
          Current_Price: 20,
          New_Price: 15,
          Current_Distribution: 15.820655533960009,
          New_Distribution: 'Base',
          Action: 'Pricing',
          valid: true,
          scenario_id: 3,
        },
      ],
      txn_gr: 0.01,
      vol_uc_gr: 0.01,
      nr_gr: 0.01,
      share_change: 0.5,
      ou_gp: 0.3,
      system_gp: 0.6,
      status: 'complete',
    },
    {
      scenario_name: 'scenario_9',
      created_date: '20-09-2024',
      user: 'user_name',
      scenario_id: 3,
      input: [
        {
          State: 'Punjab',
          Category: 'Core Sparkling',
          Bottler: 'LBPL',
          Brand: 'Fanta',
          Pack_Segment: 'SS PET',
          Pack_Size: 250,
          Current_Price: 20,
          New_Price: 15,
          Current_Distribution: 31.29469142246446,
          New_Distribution: 'Base',
          Action: 'Pricing',
          valid: true,
          scenario_id: 3,
        },
        {
          State: 'Punjab',
          Category: 'Core Sparkling',
          Bottler: 'LBPL',
          Brand: 'Limca',
          Pack_Segment: 'SS PET',
          Pack_Size: 250,
          Current_Price: 20,
          New_Price: 15,
          Current_Distribution: 49.807686785359955,
          New_Distribution: 'Base',
          Action: 'Pricing',
          valid: true,
          scenario_id: 3,
        },
        {
          State: 'Punjab',
          Category: 'Core Sparkling',
          Bottler: 'LBPL',
          Brand: 'Thums Up',
          Pack_Segment: 'SS PET',
          Pack_Size: 250,
          Current_Price: 20,
          New_Price: 15,
          Current_Distribution: 15.820655533960009,
          New_Distribution: 'Base',
          Action: 'Pricing',
          valid: true,
          scenario_id: 3,
        },
      ],
      txn_gr: 0.01,
      vol_uc_gr: 0.01,
      nr_gr: 0.01,
      share_change: 0.5,
      ou_gp: 0.3,
      system_gp: 0.6,
      status: 'in_progress',
    },
  ],
  SCENARIO_TABLE_COLUMNS: [
    { id: 'state', label: 'State' },
    { id: 'category', label: 'Category' },
    { id: 'brand', label: 'Brand' },
    { id: 'pack_size', label: 'Pack' },
    { id: 'current_price', label: 'Price' },
    { id: 'new_price', label: 'New Price' },
    { id: 'current_distribution', label: 'Distribution' },
    { id: 'new_distribution', label: 'New Distribution' },
  ],
  STATUS_MAPPER: {
    complete: 'Completed',
    draft: 'Draft',
  },
};

export const SCENARIO_CREATION_DATA = {
  DEFAULT_SUGGESTIONS: [
    {
      id: 1,
      text: "Increase the price of Coca-Cola 250ml SS PET bottle in Andhra Pradesh by 5rs & keep it's distribution at base",
    },
    {
      id: 2,
      text: 'Launch Fanta 400ml Mobile MS pack in west Bengal at rs 34. keep distribution at 10%.',
    },
    {
      id: 3,
      text: 'Replace Limca 250ml SS PET bottle by 200ml SS PET bottle in Madhya Pradesh at 15rs. Keep distribution as 5%',
    },
  ],
  TAB_DATA: [
    {
      label: 'Pricing & Distribution',
      content: {
        type: 'custom',
        data: [
          {
            Home: [1000.0, 1250.0, 1200.0],
            'Mobile MS': [750.0, 400.0, 500.0, 600.0, 475.0],
            Party: [2000.0, 2250.0, 1750.0],
            CAN: [200.0, 330.0, 300.0, 180.0, 350.0],
            'Mobile SS': [250.0],
            'Sparkling Others': [10000.0, 20000.0],
            'Water PET Super1000': [2000.0],
            'Water PET 1000': [1000.0],
            Others: [355.0, 200.0, 330.0, 300.0, 350.0],
            'Small Tetra': [200.0, 125.0, 150.0, 135.0],
            RGB: [200.0, 300.0],
            'Water PET Sub1000': [500.0, 300.0, 750.0],
            'Large Tetra': [1000.0],
          },
        ],
      },
    },
    {
      label: 'Replace',
      content: {
        type: 'replace',
        data: [
          {
            Home: [1000.0, 1250.0, 1200.0],
            'Mobile MS': [750.0, 400.0, 500.0, 600.0, 475.0],
            Party: [2000.0, 2250.0, 1750.0],
            CAN: [200.0, 330.0, 300.0, 180.0, 350.0],
            'Mobile SS': [250.0],
            'Sparkling Others': [10000.0, 20000.0],
            'Water PET Super1000': [2000.0],
            'Water PET 1000': [1000.0],
            Others: [355.0, 200.0, 330.0, 300.0, 350.0],
            'Small Tetra': [200.0, 125.0, 150.0, 135.0],
            RGB: [200.0, 300.0],
            'Water PET Sub1000': [500.0, 300.0, 750.0],
            'Large Tetra': [1000.0],
          },
        ],
      },
    },
    {
      label: 'Addition',
      content: {
        type: 'addition',
        data: [
          {
            Home: [1000.0, 1250.0, 1200.0],
            'Large Tetra': [1000.0],
            Party: [1750.0],
            'Mobile MS': [600.0],
            CAN: [180.0, 300.0],
            'Small Tetra': [150.0],
            'Water PET Super1000': [2000.0],
          },
        ],
      },
    },
  ],

  BOTTLER_OPTIONS: [
    { id: '1', name: 'First Bottler' },
    { id: '2', name: 'Second Bottler' },
  ],
  INPUT_CONSTRAINTS_CURRENT: ['Current Price', 'Current Distribution'],
  INPUT_CONSTRAINTS_COMPETITION: ['Comp. Segment Price', 'Comp. Segment Distribution'],
  INPUT_CONSTRAINTS_KO_SEGMENT: ['KO Segment PPL', 'KO Segment Distribution'],
  INPUT_CONSTRAINTS_KO_PPL: ['Comp. Segment PPL', 'Comp. Segment Distribution'],
  TABLE_DATA_CONSTANTS: [
    { id: 'sku', label: 'Category x Pack Segment', align: 'center' },
    { id: 'category', label: 'Category 2', align: 'center' },
    { id: 'volume', label: 'Vol UC', align: 'center' },
    { id: 'growth', label: 'Growth%', align: 'center' },
    { id: 'contri', label: '% Contri to NR', align: 'center' },
    { id: 'contriIndia', label: '% Contri to NR India', align: 'center' },
    { id: 'nruc', label: 'NR/UC', align: 'center' },
    { id: 'nrucIndia', label: 'NR/UC Indexed to all India', align: 'center' },
  ],
  MAPPING_TABLE: [
    {
      States: 'Punjab, Haryana',
      Category: 'All',
      Bottler: 'All',
      Brand: 'All',
      Pack_Segment: 'All',
      Packsize: 'All',
      Action: 'Pricing',
      Base_Price: 'Base',
      New_Price: 'Base+15',
      Distribution: 'Base',
    },
    {
      States: 'Punjab, Haryana',
      Category: 'Sparkling',
      Bottler: 'All',
      Brand: 'All',
      Pack_Segment: 'Unknown',
      Packsize: 'Unknown',
      Action: 'Pricing',
      Base_Price: 'Base',
      New_Price: 'Base+15',
      Distribution: 'Base',
    },
  ],
  AUDIO_MAPPING_TABLE_COLUMNS: [
    { id: 'States', label: 'State' },
    { id: 'Category', label: 'Category' },
    { id: 'Bottler', label: 'Bottler' },
    { id: 'Brand', label: 'Brand' },
    { id: 'Pack_Segment', label: 'Pack Segment' },
    { id: 'Packsize', label: 'Pack Size' },
    { id: 'Packsize_Replace', label: 'Pack Size Replace' },
    { id: 'Base_Price', label: 'Base Price' },
    { id: 'New_Price', label: 'New Price' },
    { id: 'Distribution', label: 'Distribution' },
    { id: 'Action', label: 'Actions' },
    { id: 'actions', label: 'Delete' },
  ],
  INPUT_MAPPING_TABLE_COLUMNS: [
    { id: 'State', label: 'State' },
    { id: 'Category', label: 'Category' },
    { id: 'Bottler', label: 'Bottler' },
    { id: 'Brand', label: 'Brand' },
    { id: 'Pack_Segment', label: 'Pack Segment' },
    { id: 'Pack_Size', label: 'Pack Size' },
    { id: 'Packsize_Replace', label: 'Pack Size Replace' },
    { id: 'Current_Price', label: 'Current Price' },
    { id: 'New_Price', label: 'New Price' },
    { id: 'Current_Distribution', label: 'Current Distribution' },
    { id: 'New_Distribution', label: 'New Distribution' },
    { id: 'Action', label: 'Actions' },
    { id: 'actions', label: 'Delete' },
  ],
};

export const SCENARIO_OUTPUT_DATA = {
  SELECT_MAPPER: {
    'All Segment': 'all_segment',
    'Intervened Segment': 'intervened_segment',
  },
  VIEW_BY_MAPPER: {
    Absolute: 'absulute',
    Incremental: 'incremental',
    Percent: 'percent',
  },
  VIEW_BY_MAPPER_DEEPDIVE: {
    Absolute: 'absulute',
    Incremental: 'incremental',
    Percent: 'incremental',
  },
  SCENARIO_FINANCE_MAPPER: {
    bottler_gp: 'Bottler GP',
    ou_gp: 'OU GP',
    system_gp: 'System GP',
    bottler_gp_percent: 'BU GP (%)',
    ou_gp_percent: 'OU GP (%)',
    system_gp_percent: 'System GP (%)',
  },
  BASE_RGM_MAPPER: {
    total_transactions_sum: 'Transactions',
    total_volume_sum: 'Volume (UC)',
    volume_pc: 'Volume PC',
    net_revenue_base: 'Net Revenue (INR)',
    nr_per_uc: 'NR/UC',
    base_market_share: 'Market Share (%)',
  },
  BASE_FINANCE_MAPPER: {
    bottler_gp: 'Bottler GP(INR)',
    ou_gp: 'OU GP(INR)',
    system_gp: 'System GP(INR)',
    bottler_gp_percent: 'BU GP (%)',
    ou_gp_percent: 'OU GP (%)',
    system_gp_percent: 'System GP (%)',
  },
  SCENARIO_RGM_MAPPER: {
    total_transactions_sum: 'Transactions',
    total_volume_sum: 'Volume (UC)',
    volume_pc: 'Volume PC',
    net_revenue_scenario: 'Net Revenue',
    nr_per_uc: 'NR/UC',
    scenario_market_share: 'Market Share (%)',
  },
  STATIC_OVERVIEW_DATA: [
    {
      base: {
        volume_pc: 206002807.90615845,
        base_market_share: 0.8215288638569629,
        net_revenue_base: 901988514375222.1,
        nr_per_uc: 164582394.51427776,
        total_volume_sum: 5480467.8048172,
        total_transactions_sum: 119329358.0,
      },
    },
    {
      scenario_name: 'scenario_test_1',
      result: {
        volume_pc: 206002807.90615845,
        base_market_share: 0.8215288638569629,
        net_revenue_base: 901988514375222.1,
        nr_per_uc: 164582394.51427776,
        total_volume_sum: 5480467.8048172,
        total_transactions_sum: 119329358.0,
      },
    },
    {
      scenario_name: 'scenario_1_test',
      result: {
        volume_pc: 206002807.90615845,
        base_market_share: 0.8215288638569629,
        net_revenue_base: 901988514375222.1,
        nr_per_uc: 164582394.51427776,
        total_volume_sum: 5480467.8048172,
        total_transactions_sum: 119329358.0,
      },
    },
  ],
};
